import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { SortByValuesModel } from "../sort-by-values.model";
import { ArrayModels } from "./arrays.model";
import { CustomStatusDisplay } from "./custom-status-display.model";
import { CustomDateDisplayEnum } from "src/app/core/enums/list-layout/custom-date-display-enum";

export class ColumnsModel {
    title?: string;
    dataFieldName?: string;
    sortable?: SortByValuesModel;
    visible?: string = 'true';
    order: number = 0;
    width?: string;
    type?: ColumnTypeEnum;
    customStatusClass?: CustomStatusDisplay;
    customStatusText?: CustomStatusDisplay;
    arrayModels?: ArrayModels[];
    subDataFieldName?: string;
    underTextDataFieldName?: string;
    imageUrlLink?: boolean;
    inlineEditingDropDownOptions?: { value: any, selectedText: string, dropdownText: string }[];
    arrayDelimiter?: string;

    tabulate?: boolean
    tabulationTitle?: string;
    tabulateDataFieldName?: string;

    tabulationComparisonDataFieldName?: string;
    tabulationComparisonValue?: any;

    tabulationPlaceHolder?: boolean = false;

    customDateDisplayOptionSelected?: CustomDateDisplayEnum;

    //UI Only models for display purposes
    isBeingInlineEdited?: boolean = false;


}








